var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMokey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 92,
    viewBox: "0 0 725 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 628.398,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 628.398,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 621.242,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 614.094,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 606.945,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 606.945,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 606.945,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 599.789,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 621.242,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 621.25,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 599.789,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 592.641,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 599.789,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 592.641,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 599.789,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 606.945,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 614.094,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 628.398,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#5D2214"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 628.398,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#5D2214"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 614.094,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 614.094,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#5D2214"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 606.938,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#5D2214"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 621.242,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#5D2214"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 585.484,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 578.328,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 571.18,
    y: 64.8203,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 571.18,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 571.18,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#5D2214"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 578.328,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#5D2214"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 606.945,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 599.789,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 614.094,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 621.242,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 621.242,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 621.242,
    y: 21.9072,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 614.094,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 614.094,
    y: 21.9072,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 606.945,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 606.945,
    y: 21.9072,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 599.789,
    y: 21.9072,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 599.789,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#793D20"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 592.641,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#CA9660"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 499.664 35.8611)",
    fill: "#CAC660"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 499.664 43.0132)",
    fill: "#CAC660"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 506.812 43.0132)",
    fill: "#CAC660"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 43.0132)",
    fill: "#CAC660"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 521.117 43.0132)",
    fill: "#CAC660"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 521.117 57.3176)",
    fill: "#CAC660"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 521.117 64.4698)",
    fill: "#CAC660"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 506.812 57.3176)",
    fill: "#CAC660"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 506.812 64.4698)",
    fill: "#3C2079"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 528.266 43.0132)",
    fill: "#3C2079"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 528.266 57.3176)",
    fill: "#3C2079"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 528.273 64.4698)",
    fill: "#3C2079"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 528.266 50.1654)",
    fill: "#3C2079"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 521.117 50.1654)",
    fill: "#3C2079"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 57.3176)",
    fill: "#CAC660"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 499.664 57.3176)",
    fill: "#53145D"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 492.508 57.3176)",
    fill: "#53145D"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 499.656 64.4698)",
    fill: "#3C2079"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 492.508 64.4698)",
    fill: "#3C2079"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 485.352 64.4698)",
    fill: "#3C2079"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 64.4698)",
    fill: "#3C2079"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 50.1654)",
    fill: "#53145D"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 521.117 64.4698)",
    fill: "#3C2079"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 506.812 50.1654)",
    fill: "#53145D"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 0.0996094)",
    fill: "#53145D"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 506.812 0.0996094)",
    fill: "#53145D"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 521.117 35.8611)",
    fill: "black"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 528.266 35.8611)",
    fill: "#3C2079"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 35.8611)",
    fill: "#CAC660"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 506.812 35.8611)",
    fill: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 506.812 28.7089)",
    fill: "#CAC660"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 506.812 21.5566)",
    fill: "#3C2079"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 28.7089)",
    fill: "#CAC660"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 21.5566)",
    fill: "#3C2079"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 14.4045)",
    fill: "#53145D"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 513.969 7.25183)",
    fill: "#53145D"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 521.117 28.7089)",
    fill: "#CAC660"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 521.117 21.5566)",
    fill: "#3C2079"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 528.266 21.5566)",
    fill: "#3C2079"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 528.266 28.7089)",
    fill: "#3C2079"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 528.273 35.8611)",
    fill: "#CAC660"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 139.898 43.3643)",
    fill: "white"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 132.75 43.3643)",
    fill: "white"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 132.75 50.5165)",
    fill: "white"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 132.75 57.6687)",
    fill: "white"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 132.75 64.8214)",
    fill: "white"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 118.445 64.8214)",
    fill: "white"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 111.297 64.8214)",
    fill: "white"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 111.297 50.5165)",
    fill: "white"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 104.141 50.5165)",
    fill: "#F0621D"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 132.75 71.9735)",
    fill: "#F0621D"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 118.445 71.9735)",
    fill: "#F0621D"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 111.297 71.9741)",
    fill: "#F0621D"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 125.602 71.9735)",
    fill: "#F0621D"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 125.602 64.8214)",
    fill: "#F0621D"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 118.445 57.6687)",
    fill: "white"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 118.445 43.3643)",
    fill: "#FF3100"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 125.602 36.2117)",
    fill: "#FF3100"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 96.9922 43.3643)",
    fill: "#F0621D"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 96.9922 36.2117)",
    fill: "#F0621D"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 96.9922 29.0594)",
    fill: "#F0621D"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 111.297 57.6687)",
    fill: "#F0621D"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 125.602 57.6687)",
    fill: "#FF3100"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 111.297 64.8214)",
    fill: "#F0621D"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 125.602 50.5165)",
    fill: "#FF3100"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 139.898 64.8214)",
    fill: "black"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 139.898 71.9735)",
    fill: "#F0621D"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 139.898 57.6687)",
    fill: "white"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 139.898 50.5165)",
    fill: "black"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 147.055 50.5165)",
    fill: "white"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 154.203 50.5165)",
    fill: "#F0621D"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 147.055 57.6687)",
    fill: "white"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 154.203 57.6687)",
    fill: "#F0621D"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 161.359 57.6687)",
    fill: "#FF3100"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 147.055 64.8214)",
    fill: "white"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 154.203 64.8214)",
    fill: "#F0621D"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 154.203 71.9735)",
    fill: "#F0621D"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 147.055 71.9735)",
    fill: "#F0621D"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 139.898 71.9735)",
    fill: "white"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 230.023 43.1447)",
    fill: "#A5CAEC"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 230.023 35.9924)",
    fill: "#A5CAEC"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 222.875 35.9924)",
    fill: "#A5CAEC"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 215.719 35.9924)",
    fill: "#A5CAEC"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 208.57 35.9924)",
    fill: "#A5CAEC"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 208.57 21.6881)",
    fill: "#A5CAEC"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 222.875 21.6881)",
    fill: "#A5CAEC"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 201.414 35.9924)",
    fill: "#1898F4"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 201.414 21.6881)",
    fill: "#1898F4"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 201.414 28.8403)",
    fill: "#1898F4"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 208.57 28.8403)",
    fill: "#1898F4"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 215.719 21.6881)",
    fill: "#A5CAEC"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 230.023 21.6881)",
    fill: "#1820D8"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 237.18 21.6881)",
    fill: "#1820D8"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 194.266 21.6881)",
    fill: "#1898F4"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 215.719 28.8403)",
    fill: "#1820D8"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 187.109 21.6881)",
    fill: "#1898F4"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 222.875 28.8403)",
    fill: "#1820D8"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 222.867 71.7539)",
    fill: "#1820D8"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 230.023 71.7539)",
    fill: "#1820D8"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 208.57 43.1447)",
    fill: "black"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 201.414 43.1447)",
    fill: "#1898F4"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 215.719 43.1447)",
    fill: "#A5CAEC"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 222.875 43.1447)",
    fill: "black"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 222.875 50.2969)",
    fill: "#A5CAEC"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 222.875 57.449)",
    fill: "#1898F4"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 215.719 50.2969)",
    fill: "#A5CAEC"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 215.719 57.449)",
    fill: "#1898F4"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 222.867 64.6017)",
    fill: "#1820D8"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 215.719,
    y: 71.7539,
    width: 7.15226,
    height: 7.15226,
    transform: "rotate(180 215.719 71.7539)",
    fill: "#1820D8"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 208.562,
    y: 71.7539,
    width: 7.15226,
    height: 7.15226,
    transform: "rotate(180 208.562 71.7539)",
    fill: "#1820D8"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 215.719,
    y: 64.6017,
    width: 7.15226,
    height: 7.15226,
    transform: "rotate(180 215.719 64.6017)",
    fill: "#1820D8"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 208.57 50.2969)",
    fill: "#A5CAEC"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 208.57 57.449)",
    fill: "#1898F4"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 201.414 57.449)",
    fill: "#1898F4"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 201.414 50.2969)",
    fill: "#1898F4"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 201.414 43.1447)",
    fill: "#A5CAEC"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 307.625 36.2115)",
    fill: "#E4A4DE"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 307.625 43.3638)",
    fill: "#E4A4DE"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 314.773 43.3638)",
    fill: "#E4A4DE"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 321.922 43.3638)",
    fill: "#E4A4DE"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 329.078 43.3638)",
    fill: "#E4A4DE"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 329.078 57.6682)",
    fill: "#E4A4DE"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 329.078 64.8208)",
    fill: "#E4A4DE"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 314.773 57.6682)",
    fill: "#E4A4DE"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 314.773 64.8208)",
    fill: "#8A208C"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 336.227 43.3638)",
    fill: "#8A208C"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 336.227 57.6682)",
    fill: "#8A208C"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 336.234 64.8208)",
    fill: "#8A208C"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 336.227 50.516)",
    fill: "#8A208C"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 329.078 50.516)",
    fill: "#8A208C"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 321.922 57.6682)",
    fill: "#E4A4DE"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 307.625 57.6682)",
    fill: "#9813BA"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 300.469 57.6682)",
    fill: "#E4A4DE"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 307.617 64.8208)",
    fill: "#8A208C"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 300.469 64.8208)",
    fill: "#8A208C"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 293.312 64.8208)",
    fill: "#8A208C"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 321.922 64.8208)",
    fill: "#8A208C"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 321.922 50.516)",
    fill: "#9813BA"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 329.078 64.8208)",
    fill: "#8A208C"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 314.773 50.516)",
    fill: "#9813BA"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 286.164,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#9813BA"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 293.312,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#9813BA"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 329.078 36.2115)",
    fill: "black"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 336.227 36.2115)",
    fill: "#8A208C"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 321.922 36.2115)",
    fill: "#E4A4DE"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 314.773 36.2115)",
    fill: "black"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 314.773 29.0594)",
    fill: "#E4A4DE"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 314.773 21.9072)",
    fill: "#8A208C"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 321.922 29.0594)",
    fill: "#E4A4DE"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 321.922 21.9072)",
    fill: "#8A208C"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 286.164,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#9813BA"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 286.164,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#9813BA"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 329.078 29.0594)",
    fill: "#E4A4DE"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 329.078 21.9072)",
    fill: "#8A208C"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 336.227 21.9072)",
    fill: "#8A208C"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 336.227 29.0594)",
    fill: "#8A208C"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15226,
    height: 7.15226,
    transform: "matrix(-1 0 0 1 336.227 36.2115)",
    fill: "#E4A4DE"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 422.414,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 422.414,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 415.258,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 408.109,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 400.961,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 400.961,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 400.961,
    y: 64.8208,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 393.805,
    y: 64.8208,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 415.258,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 415.266,
    y: 64.8208,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 393.805,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 386.656,
    y: 64.8208,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 393.805,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 386.656,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 393.805,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 386.648,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 379.5,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 379.5,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 400.961,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 408.109,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 422.414,
    y: 57.6682,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 422.414,
    y: 64.8208,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 408.109,
    y: 64.8208,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 408.109,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 400.953,
    y: 64.8208,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 415.258,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 422.414,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 429.562,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 436.719,
    y: 50.516,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 436.719,
    y: 43.3638,
    width: 7.15226,
    height: 7.15226,
    fill: "#166209"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 400.961,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "black"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 393.805,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 408.109,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 415.258,
    y: 36.2115,
    width: 7.15226,
    height: 7.15226,
    fill: "black"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 415.258,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 415.258,
    y: 21.9072,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 408.109,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 408.109,
    y: 21.9072,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 400.961,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 400.961,
    y: 21.9072,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 393.805,
    y: 21.9072,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 393.805,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#227920"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 386.656,
    y: 29.0594,
    width: 7.15226,
    height: 7.15226,
    fill: "#99DEAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M674.379 72.1021H684.392V81.9869H674.379V91.9998L41.0327 91.9998V72.1021L674.379 72.1021Z",
    fill: "#FE207E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M684.392 81.9869L694.404 81.9868V91.9996H684.391L684.392 81.9869Z",
    fill: "#FE207E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9786 81.987H10.9659V91.9996H0.953125V81.9868L10.9659 81.987L10.9658 71.9742H20.9786V81.987Z",
    fill: "#FE207E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M714.43 71.9741H704.417V81.9869L694.404 81.9868V91.9996H704.417L704.417 81.9869H714.43V71.9741Z",
    fill: "#FE207E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9786 81.987L41.0043 81.9868V91.9996H20.9788L20.9786 81.987Z",
    fill: "#FE207E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M724.443 81.9868L714.43 81.9869L714.43 91.9996H724.443V81.9868Z",
    fill: "#FE207E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMokey);
export default __webpack_public_path__ + "static/media/mokey.8acf7b99845dd873825b1f64440d5129.svg";
export { ForwardRef as ReactComponent };